

const formatAuthCode = (code: any) => { 

    if (code) { 

        const stringifiedCode = code.toString(); 

        return Number(stringifiedCode.replaceAll(/\D/g,''));  

    } else { 
        return code;
    }
  
    
};

export default formatAuthCode; 